var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Tooltip } from "@animech/ui";
export var CustomUITooltip = function (props) {
    return (_jsx(Tooltip, __assign({}, props, { children: _jsx("div", { onMouseDown: function (e) { return e.stopPropagation(); }, onClick: function (e) { return e.stopPropagation(); }, onMouseMove: function (e) {
                e.stopPropagation();
            }, children: props.children }) })));
};
